import { render, staticRenderFns } from "./AppRegister.vue?vue&type=template&id=53f1f872&"
import script from "./AppRegister.vue?vue&type=script&lang=js&"
export * from "./AppRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports